import React, { useState } from 'react';
import { Flame } from 'lucide-react';

// Official FlameLink artwork (transparent WebP + PNG fallback). Falls back to the Lucide flame if an image fails to load.
const SRC = {
  script: { base: '/brand/flamelink-script', aspect: 1241 / 1165, alt: 'FlameLink crowned heart logo' },
  wings: { base: '/brand/flamelink-wings', aspect: 1242 / 1249, alt: 'FlameLink crowned wings logo' },
};
const srcset = (base, ext) => `${base}-160.${ext} 160w, ${base}-480.${ext} 480w, ${base}-1000.${ext} 1000w`;

export const BrandLogo = ({ variant = 'script', className = '', sizes = '160px', priority = false, testId }) => {
  const [failed, setFailed] = useState(false);
  const a = SRC[variant];
  if (failed) return <Flame className={`text-red-500 ${className}`} data-testid={testId} aria-label={a.alt} />;
  return (
    <picture data-testid={testId}>
      <source type="image/webp" srcSet={srcset(a.base, 'webp')} sizes={sizes} />
      <img
        src={`${a.base}-480.png`}
        srcSet={srcset(a.base, 'png')}
        sizes={sizes}
        alt={a.alt}
        width={480}
        height={Math.round(480 / Number(a.aspect))}
        className={`select-none ${className}`}
        style={{ aspectRatio: String(a.aspect) }}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        draggable={false}
        onError={() => setFailed(true)}
      />
    </picture>
  );
};

// Compact lockup for navigation bars: emblem + legible wordmark (the emblem's lettering is too small alone at nav height).
export const BrandLockup = ({ size = 'md', light = false, className = '', testId = 'brand-lockup' }) => {
  const h = size === 'sm' ? 'h-11' : size === 'lg' ? 'h-20' : 'h-14';
  const t = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-3xl' : 'text-2xl';
  return (
    <div className={`flex items-center gap-2 shrink-0 ${className}`} data-testid={testId}>
      <BrandLogo variant="script" className={`${h} w-auto drop-shadow-sm`} sizes="80px" priority />
      <span className={`${t} hidden min-[360px]:inline font-bold bg-gradient-to-r ${light ? 'from-amber-200 via-pink-300 to-rose-300' : 'from-amber-500 via-rose-500 to-fuchsia-600'} bg-clip-text text-transparent leading-none`}>
        FlameLink
      </span>
    </div>
  );
};
